// Shared layout constants for the app
export const SIDEBAR_WIDTH = 250; // px, keep in sync with sidebar width prop
